import defaultClient from '@/plugins/axios/defaultClient'
// import qs from 'query-string'
// import proxyClient from '@/plugins/axios/proxyClient'

export default {
  postMarketplaceLoanOffers(data) {
    return defaultClient.post(`/loan-marketplace/loan-offers/`, { details: data })
  },

  postMarketplaceLoanOfferApply(uuid) {
    return defaultClient.post(`/loan-marketplace/loan-offers/${uuid}/apply/`)
  },
}
